import type { CustomRoleTaxonomySelection } from '@revelio/data-access';

import { useRoleTreeSelectionLists } from '../../../../shared/selection-lists/hooks/useRoleTreeSelectionLists';
import {
  type RoleSelectionListKey,
  roleSelectionListKeys,
  type SelectionListState,
} from '../../../../shared/selection-lists/types';
import { useIsTaxonomyResolved } from '../contexts/FilterProvider';
import { useFilterState } from '../hooks/useFilters';
import { FilterId, type SingleValueFilter } from '../types/filters';

export type RoleSelectionListState = SelectionListState<RoleSelectionListKey>;

export const useRoleSelectionLists = (): RoleSelectionListState | null => {
  const { filterState: roleTaxonomyFilterState } = useFilterState<
    SingleValueFilter<CustomRoleTaxonomySelection>
  >(FilterId.ROLE_TAXONOMY);
  const isTaxonomyResolved = useIsTaxonomyResolved();

  // `value` is typed as required, but is undefined while the adaptive taxonomy
  // is still resolving — pause the fetch rather than reading it.
  const taxonomyId: CustomRoleTaxonomySelection | undefined =
    roleTaxonomyFilterState.value;

  // Full role hierarchy from the role TaxonomyTree (the breadcrumb subfilter
  // nests every level); getRoleTaxonomyId reads the taxonomy id and ignores
  // the version, so no version-stripping is needed here.
  return useRoleTreeSelectionLists({
    requiredKeys: roleSelectionListKeys,
    taxonomySelection: taxonomyId,
    pause: !isTaxonomyResolved || !taxonomyId,
  });
};
